export default "__VITE_ASSET__6a713c90__"